import * as actionTypes from "../actionTypes";

export const getCompanies = function () {
  return { type: actionTypes.GET_COMPANIES };
};

export const saveCompany = function (company) {
  return { type: actionTypes.SAVE_COMPANY, payload: company };
};
